import { ISelectOption } from '@widgets/single-select';

export enum Quarter {
  Q1 = 1,
  Q2 = 2,
  Q3 = 3,
  Q4 = 4,
}

// const QUARTERS_: Quarter[] = [Quarter.Q1, Quarter.Q2, Quarter.Q3, Quarter.Q4];

// export const QUARTER_LABEL: Record<Quarter, string> = {
//     [Quarter.Q1]: "Q1",
//     [Quarter.Q2]: "Q2",
//     [Quarter.Q3]: "Q3",
//     [Quarter.Q4]: "Q4",
// };

export const monthNamesRu = [
  'Янв',
  'Фев',
  'Мар',
  'Апр',
  'Май',
  'Июн',
  'Июл',
  'Авг',
  'Сен',
  'Окт',
  'Ноя',
  'Дек',
];

export function getQuarterCurrent(): number {
  return Math.floor(new Date().getMonth() / 3) + 1;
}

export function getQuarterByDate(date: Date = new Date()): Quarter {
  const m = date.getMonth();
  return (Math.floor(m / 3) + 1) as Quarter;
}

export function getQuarterByMonthIndex(m: number): Quarter {
  return Math.floor(m / 3) + 1;
}
